/** Where a trip to Google may send the browser (calendar-sync-requirements R2). Pure. */

/** The consent page is Google's and nobody else's: the one string off the wire that becomes navigation. */
export function isGoogleConsentUrl(url: string | null | undefined): url is string {
  if (typeof url !== 'string') return false;
  try {
    return new URL(url).origin === 'https://accounts.google.com';
  } catch {
    return false;
  }
}
